var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "url(#paint0_linear_769_65121)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3696 11.8262C40.5973 11.8262 45.6414 16.8703 45.6414 23.0979C45.6414 29.3255 40.5973 34.3696 34.3696 34.3696C28.142 34.3696 23.0979 29.3255 23.0979 23.0979C23.0979 16.8703 28.142 11.8262 34.3696 11.8262ZM34.3696 56.9131C34.3696 56.9131 56.9131 56.9131 56.9131 51.2773C56.9131 44.5142 45.9232 37.1876 34.3696 37.1876C22.8161 37.1876 11.8262 44.5142 11.8262 51.2773C11.8262 56.9131 34.3696 56.9131 34.3696 56.9131Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_769_65121",
    x1: 15.1522,
    y1: 68,
    x2: 43.2391,
    y2: 8.86957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CF4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B6E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManAvatar);
export default __webpack_public_path__ + "static/media/man-avatar.330084221e48b00ae0f43f699c68c501.svg";
export { ForwardRef as ReactComponent };